export default __webpack_public_path__ + "static/media/home-hero-1000.150bad04.jpg";